module.exports = __webpack_public_path__ + "media/images/success/1-0152c946840e6e05b7297d292bbe6def.png";